import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import withMessages from '../../utilities/intl';

import styles from './splitview.scss';

const BASE_KEY = 'components.split_view.toggle_buttons';

function ToggleButtonToSplitViewComponent({ getMessage, onClick }) {
    return (<span
        role="presentation"
        data-toggle="table-view"
        data-action="switch-to-split-view"
        className={styles['splitview-toggle-view']}
        onClick={onClick}
    >
        <span className={styles['action-splitview']}>
            {getMessage(`${BASE_KEY}.split_view`)}
        </span>
    </span>)
}

ToggleButtonToSplitViewComponent.propTypes = {
    onClick: PropTypes.func,
    getMessage: PropTypes.func,
};

ToggleButtonToSplitViewComponent.defaultProps = {
    onClick: () => {},
    getMessage: () => {},
};

const ToggleButtonToSplitView = withMessages(ToggleButtonToSplitViewComponent);
ToggleButtonToSplitView.displayName = displayName('SplitView/ToggleButtonToSplitView');

export default ToggleButtonToSplitView;
